import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@app/_shared/_services/authentication.service';
import { UsersService } from '@app/_shared/_services/users.service';
import { environment } from '@environments/environment';
import { first } from 'rxjs/operators';
import { alert } from 'devextreme/ui/dialog';
import { GlobalHelper } from '@app/_shared/_helpers/global.helper';

@Component({
  selector: 'auth-formpassword',
  templateUrl: './formpassword.component.html',
  styleUrls: ['./formpassword.component.scss']
})
export class AuthentificationFormpasswordComponent implements OnInit {

  verifyForm: UntypedFormGroup;
  passwordForm: UntypedFormGroup;
  loading = false;
  submitted = false;
  error = '';
  environment = environment;

  user;
  token;
  @Input() withPassword:boolean;
  @Output() withPasswordChange:EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private formBuilder: UntypedFormBuilder,
    private globalHelper:GlobalHelper,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService, private usersService: UsersService) { }



  ngOnInit(): void {

    let username = this.route.snapshot.queryParams.u;
    this.token = this.route.snapshot.queryParams.token;
    if(this.token){
      this.passwordForm = this.formBuilder.group({
        password: ['', Validators.required, Validators.minLength(6)],
        confirmPassword: ['', Validators.required],
      }, {
        validator: this.globalHelper.MustMatch('password', 'confirmPassword')
    });


      // get user by tokens
      this.usersService.getItems({where:{resetPasswordToken:this.token}}).subscribe(res=>{
        this.user = res.items[0];
      })
    }
else{
  this.verifyForm = this.formBuilder.group({
      username: [(username?username:''), Validators.required]
  });}

  }
  goBack() {
    if(window){
    window.history.back();
    }
  }
  toggleWithPassword(){
    this.withPassword = !this.withPassword;
    this.withPasswordChange.emit(this.withPassword)
  }

  // convenience getter for easy access to form fields
  get vf() { return this.verifyForm.controls; }
  get pf() { return this.passwordForm.controls; }

  onSubmitVerify($event) {
    $event.stopPropagation();
      this.submitted = true;

      // stop here if form is invalid
      if (this.verifyForm.invalid) {
          return;
      }
      // verify email

      this.loading = true;
      this.authenticationService.verifyResetPassword(this.vf.username.value)
          .pipe(first())
          .subscribe({
              next: (res) => {
                this.loading = false;


                alert('Un mail vous a été envoyé. Merci de cliquez sur le lien présent dans celui-ci pour pouvoir réinitialiser votre mot de passe.','Réinitialisation')


                // console.log('ok',this.route.snapshot.queryParams['returnUrl'] )
                //   // get return url from route parameters or default to '/'
                //   const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
                //   this.router.navigate([returnUrl]);
              },
              error: error => {
                if(typeof error === 'object'){
                  this.error = error.msg;
                }
                else{
                  this.error = error;
                }
                if(this.error == "unexist"){
                  this.error = "Cette adresse email n'existe pas."
                }
                if(this.error == "client not exist"){
                  this.error = "Cette adresse email n'existe pas."
                }
                if(this.error == "already exist"){
                  this.error = "Votre compte existe déjà."
                }
                  this.loading = false;
              }
          });

  }
  onSubmitReset($event) {
    $event.stopPropagation();
      this.submitted = true;

      // stop here if form is invalid
      if (this.pf.invalid || this.pf.confirmPassword?.errors?.mustMatch) {
          return;
      }
      // verify email

      this.loading = true;
      this.authenticationService.resetPassword(this.pf.password.value,this.token)
          .pipe(first())
          .subscribe({
              next: (res) => {

                this.loading = false;

                alert('Votre mot de passe a bien été modifié. Vous allez être redirigé vers la page de connexion','Réinitialisation')

                // Utiliser l'email de l'utilisateur chargé (gère correctement les caractères spéciaux)
                const userEmail = this.user?.email || this.route.snapshot.queryParams.u;
                const qp = userEmail ? { u: userEmail } : {};
                this.router.navigate(["/auth/login"], { queryParams: qp });
              },
              error: error => {
                if(typeof error === 'object'){
                  this.error = error.msg;
                }
                else{
                  this.error = error;
                }
                if(this.error == "unexist"){
                  this.error = "Cette adresse email n'existe pas."
                }
                if(this.error == "client not exist"){
                  this.error = "Cette adresse email n'existe pas."
                }
                if(this.error == "already exist"){
                  this.error = "Votre compte existe déjà."
                }
                  this.loading = false;
              }
          });

  }

  goToLogin(withoutParams?){
    console.log('goToLogin ?')
    if(!this.route.snapshot.queryParams)
    this.route.snapshot.queryParams = {};
    let qp = this.route.snapshot.queryParams;
    if(this.verifyForm && this.vf?.username?.value)
    qp = { ...this.route.snapshot.queryParams, u : this.vf.username.value}
    if(this.passwordForm && this.pf?.username?.value)
    qp = { ...this.route.snapshot.queryParams, u : this.pf.username.value}

    if(!withoutParams)
    this.router.navigate(['/auth/login'],{queryParams:qp})
    else
    this.router.navigate(['/auth/login'])
  }
  goToSignin(withoutParams?){
    console.log('goToLogin ?')
    if(!this.route.snapshot.queryParams)
    this.route.snapshot.queryParams = {};
    let qp = this.route.snapshot.queryParams;
    if(this.verifyForm && this.vf?.username?.value)
    qp = { ...this.route.snapshot.queryParams, u : this.vf.username.value}
    if(this.passwordForm && this.pf?.username?.value)
    qp = { ...this.route.snapshot.queryParams, u : this.pf.username.value}

    if(!withoutParams)
    this.router.navigate(['/signin'],{queryParams:qp})
    else
    this.router.navigate(['/signin'])
  }

}
